module.exports = __webpack_public_path__ + "img/nami.dd4448cf.png";